import { Chip, FormControl, MenuItem, Select, styled } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";


export const SelectContainer = styled(Select)(() => ({
    "& .icon": {
        right: "15px",
    },
}));

export const FormControlSingle = styled(FormControl)(({ inputvalue }) => ({
    "& label": {
        fontSize: "12px",
        color: "#2c2f44",
        fontFamily: 'Roboto, sans-serif',
        textTransform: "inherit",
    },
    "& label.MuiInputLabel-shrink": {
        fontSize: "12px",
        backgroundColor: "white",
    },
    "& label.Mui-focused": {
        color: "#638dff",
    },
    "& div": {
        padding: "5px",
        paddingBottom: "4px",
    },
    "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        border: "1px solid #638dff !important",
    },
    "& .MuiSelect-icon": {
        color: "#638dff !important",
        transform: "rotateZ(0deg)",
    },
    "& .MuiOutlinedInput-root": {
        "& .MuiSelect-select": {
            ...(inputvalue.length > 40 && { maxWidth: "18rem", marginRight: "1.5rem" })
        },
        "& fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#c4d8ff",
        },
        "&:hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#92afff",
        },
        "&.Mui-disabled": {
            backgroundColor: "#f4f7fb !important",
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4d8ff",
            },
        },
        "&.Mui-error": {
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#f2a29d !important",
            },
        },
        "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#638dff",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            color: "#44485a",
            "WebkitTextFillColor": "#44485a",
        },
        fontSize: "14px",
        borderRadius: 4,
        fontFamily: 'Roboto, sans-serif',
        backgroundColor: "white",
        color: "#2c2f44",
        position: "relative !important",
    },
}));

export const FormControlMultiple = styled(FormControl)(
    ({ isValue, multiSelWidth }) => ({
        "& label": {
            fontSize: "10px",
            color: "#2c2f44",
            fontFamily: 'Roboto, sans-serif',
            textTransform: "inherit",
            backgroundColor: "white !important",
        },
        "& label.MuiInputLabel-shrink": {
            fontSize: "14px",
        },
        "& label.Mui-focused": {
            color: "#638dff",
        },
        "& div": {
            padding: "4px 5px 6px 5px",
            paddingBottom: "4px",
        },
        "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "#638dff !important",
        },
        "& .MuiSelect-icon": {
            color: "#638dff !important",
        },
        "& .MuiOutlinedInput-root": {
            "& .MuiSelect-select": {
                ...(isValue ? { maxWidth: `${multiSelWidth}px` } : { width: "100%" }),
            },
            "& fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#c4d8ff",
            },
            "&:hover fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#92afff",
            },
            "&.Mui-disabled": {
                backgroundColor: "#f4f7fb !important",
                "& fieldset.MuiOutlinedInput-notchedOutline": {
                    borderColor: "#c4d8ff",
                },
            },
            "&.Mui-error": {
                "& fieldset.MuiOutlinedInput-notchedOutline": {
                    borderColor: "#f2a29d !important",
                },
            },
            "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
                borderColor: "#638dff",
            },
            "& .MuiOutlinedInput-input.Mui-disabled": {
                color: "#44485a",
                "WebkitTextFillColor": "#44485a",
            },
            "& .MuiFormHelperText-root": {
                color: "#e5453b !important",
            },
            fontSize: "14px",
            borderRadius: 4,
            fontFamily: 'Roboto, sans-serif',
            position: "relative !important",
        },
    })
);

export const ChipsContainer = styled("div")(() => ({
    display: "flex",
    flexWrap: "wrap",
}));

export const ChipText = styled(Chip)(() => ({
    margin: 2,
    border: "solid 1px #c4d8ff",
    backgroundColor: "#f6f8fc",
    fontSize: "14px",
    fontWeight: "500",
    color: "#4f5b7d",
    "&	.MuiChip-deleteIcon": {
        color: "#4f5b7d",
        fontSize: "medium",
    },
}));

export const PositionCloseIcon = styled(ClearIcon)(() => ({
    position: "absolute",
    // left: "84%",
    //top: "calc(50% - 12px)",
    // top: "10px",
    top: "18px",
    right: "10px",
    transform: " translate(-50%, -50%) ",
    color: "rgba(0, 0, 0, 0.54)",
}));

export const PositionCloseIconMulti = styled(ClearIcon)(() => ({
    position: "absolute",
    // left: "84%",
    // top: "10px",
    // top: "calc(50% - 3px)",
    color: "rgba(0, 0, 0, 0.54)",

    //aditya
    top: " 45%  ",
    left: "87% ",
    transform: " translate(-50%, -50%) ",
}));

export const StyledMenuItem = styled(MenuItem)({
    "&.MuiButtonBase-root.MuiMenuItem-root.Mui-selected": {
        backgroundColor: "#eff4ff !important",
    },
    borderBottom: "1px solid rgba(196, 216, 255, 0.5)",
    paddingTop: "5px",
    paddingBottom: "5px",
});